<template>
  <div class="service">
    <div class="name">我们的服务</div>
    <div class="border"></div>
    <div class="lable">业内领先的区块链全生态服务提供商</div>
    <div class="productItem">
      <div
        class="productItemFor"
        v-for="(item, index) in productNavList"
        @mouseenter="productNavIndex = index"
        :class="{ active: index === productNavIndex }"
      >
        <div class="img">
          <img
            v-show="productNavIndex === index"
            src="./../../assets/home/Bitmap.png"
            alt=""
          />
        </div>
        <span>{{ item }}</span>
      </div>
    </div>
    <div
      v-for="(item, index) in productList"
      v-show="productNavIndex === index"
      class="product"
    >
      <div class="productcontent">
        <div class="servicecontent">
          <div class="productlable">
            {{ item.text }}
          </div>
          <div class="img">
            <img :src="item.img1" alt="" />
            <img :src="item.img2" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "we-service",
  data() {
    return {
      productNavList: [
        "区块链基础设施",
        "区块链服务平台",
        "区块链行业解决方案",
        "区块链应用平台",
      ],
      productNavIndex: 0,
      productList: [
        {
          text: "为政府、企业的各行业各场景技术需求，提供公有链、联盟链、私有链构建、区块链应用落地底层技术支撑服务。",
          img1: require("./../../assets/home/product1.png"),
          img2: require("./../../assets/home/product2.png"),
        },
        {
          text: "区块链服务中台，综合运用安全方计算、全同态加密、代理重块加密等技术，依托可信执行环境，提供多方安全隐私计算服务。",
          img1: require("./../../assets/home/product3.png"),
          img2: require("./../../assets/home/product4.png"),
        },
        {
          text: "根据不同业务场景，为企业提供区链行业解决方案，包括：方案设计、平台搭建、定制开发、合约编写、系统对接、运维升级等。",
          img1: require("./../../assets/home/product5.png"),
          img2: require("./../../assets/home/product6.png"),
        },
        {
          text: "为中小企业与个人用户，快速建立区块链开发环境，提供基于区块链的应用开发、测试验证、组件支持等服务。",
          img1: require("./../../assets/home/product7.png"),
          img2: require("./../../assets/home/product8.png"),
        },
      ],
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
    .service {
        max-width: 1280px;
        margin: 0 auto;
        text-align: center;
        .name {
            height: 45px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 900;
            color: #21242A;
            line-height: 45px;
        }
        .border {
            margin: 20px auto;
            width: 27px;
            height: 3px;
            background-color: #056DFF;
        }
        .lable {
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #7c7878;
            line-height: 20px;
            margin-bottom: 50px;
        }
        .productItem{
            display: flex;
            width: 100%;
            margin-top: 60px;
            .productItemFor{
                height: 40px;
                width: 25%;
                margin-bottom: 40px;
                line-height: 40px;
                /*text-align: center;*/
                .img{
                    /*margin-bottom: 5px;*/
                    position: absolute;
                    width: 3.5%;
                    /*width: 40px;*/
                    height: 40px;
                    cursor:pointer;
                    img{
                        position: absolute;
                        right: 0;
                        /*text-align: right;*/
                    }
                }
                span{
                    text-align: center;
                    cursor:pointer;
                    &:hover{

                    }
                }
            }
            .active{
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #282F3C;
                transition-duration: 0.5s;
                /*line-height: 25px;*/
            }
        }
        .product{
            .productcontent{
                width: 100%;
                height: 190px;
                background: url("../../assets/home/productBG.png");
                background-size: 100% 100%;
                .servicecontent{
                    display: flex;
                    .productlable{
                        width: 600px;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 25px;
                        text-align: left;
                        margin: 70px;
                    }
                    .img{
                        margin: 40px 70px;
                        img{
                            width: 100px;
                            height: 100px;
                            margin: 0 35px;
                        }
                    }
                }
            }
        }
    }
</style>
